import { IAutorizacoes } from './../../../interfaces/token/IAutorizacoes';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { IBoleto, ICliente, IGetBoletosQueryParams } from 'src/app/interfaces';
import { ListaPaginada } from 'src/app/models';
import { BoletoService, ClienteService } from 'src/app/services';
import { ModalDownloadBoletoComponent } from '../../../components/modal-download-boleto/modal-download-boleto.component';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { IToken } from 'src/app/interfaces/token/IToken';
import { downloadArquivoDeBase64 } from 'src/app/helper';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';

@Component({
  selector: 'app-listar-boletos',
  templateUrl: './listar-boletos.component.html',
  styleUrls: ['./listar-boletos.component.scss']
})
export class ListarBoletosComponent implements OnInit, OnDestroy {
  @ViewChild(ModalDownloadBoletoComponent)
  modalDownloadBoleto: ModalDownloadBoletoComponent;
  private subscriptions$ = new Subscription();
  form: FormGroup;
  boletos = new ListaPaginada<IBoleto>();
  clientes = new ListaPaginada<ICliente>();
  token: IToken = this.authenticationService.obterToken();
  autorizacoes: IAutorizacoes;
  gerenciarPermissoesTela() {
    this.autorizacoes = this.authenticationService.obterToken()['autorizacoes'];
  }

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private boletoService: BoletoService,
    private clienteService: ClienteService,
    private authenticationService: AuthenticationService,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  excedeTamanho(el: HTMLElement): boolean {
    return el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
  }

  getBoleto(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.boletos.paginaAtual = 1;
    }

    const valorFormulario = this.form.value;
    const queryParams: IGetBoletosQueryParams = {
      codContrato: this.token?.codContrato,
      codCliente: valorFormulario.codCliente
        ? [valorFormulario.codCliente]
        : [],
      codGrupoEconomico: this.token?.codGrupoEconomico,
      tipoUsuario: this.token?.tipoUsuario,
      itensPorPagina: this.boletos.itensPorPagina,
      paginaAtual: this.boletos.paginaAtual
    };

    if (
      valorFormulario?.vencido !== null &&
      valorFormulario?.vencido !== undefined
    ) {
      queryParams.vencido = valorFormulario.vencido;
    }

    if (valorFormulario?.pago !== null && valorFormulario?.pago !== undefined) {
      queryParams.pago = valorFormulario.pago;
    }

    this.subscriptions$.add(
      this.boletoService.getBoletos(queryParams).subscribe({
        next: ({ data }) => {
          this.boletos = data;
        }
      })
    );
  }
  getCliente() {
    this.subscriptions$.add(
      this.clienteService
        .getClientes({
          idUsuario: this.token.id,
          paginar: false
        })
        .subscribe({
          next: ({ data }) => {
            this.clientes = data;
          }
        })
    );
  }

  downloadBoleto({
    codCliente: cliente,
    empresa: empresa,
    codFatura: movimento,
    tipo
  }: IBoleto) {
    tipo = '03';
    this.subscriptions$.add(
      this.boletoService
        .postBoletoDownload({ cliente, empresa, movimento, tipo })
        .subscribe({
          next: ({ data }) => {
            if (data != null) {
              downloadArquivoDeBase64({
                base64: data,
                tipo: 'application/pdf'
              });
            }
          }
        })
    );
  }

  openModal(boleto: IBoleto) {
    this.modalDownloadBoleto.openModal(boleto);
  }
  closeModal() {
    this.modalService.dismissAll();
  }

  ngOnInit() {
    this.form = this.fb.group({
      vencido: [null],
      pago: [null],
      situacao: ['todos'],
      codCliente: ['']
    });
    this.subscriptions$.add(
      this.form.get('situacao')?.valueChanges.subscribe({
        next: (situacao) => {
          if (situacao === 'emAtraso') {
            this.form.patchValue({
              vencido: true,
              pago: false
            });
            return;
          }

          if (situacao === 'aVencer') {
            this.form.patchValue({
              vencido: false,
              pago: null
            });
            return;
          }

          if (situacao === 'pago') {
            this.form.patchValue({
              vencido: null,
              pago: true
            });
            return;
          }

          if (situacao === 'todos') {
            this.form.patchValue({
              vencido: null,
              pago: null
            });
            return;
          }
        }
      })
    );
    this.getCliente();
    this.getBoleto();
    this.gerenciarPermissoesTela();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
